import React from 'react';
interface SelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: {
    value: string;
    label: string;
  }[];
  error?: string;
  required?: boolean;
  className?: string;
}
export function Select({
  label,
  value,
  onChange,
  options,
  error,
  required = false,
  className = ''
}: SelectProps) {
  const id = `select-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return <div className={`flex flex-col ${className}`} data-id="element-265">
      <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-2" data-id="element-266">
        {label} {required && <span className="text-red-500" data-id="element-267">*</span>}
      </label>
      <select id={id} value={value} onChange={e => onChange(e.target.value)} required={required} className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all appearance-none bg-white ${error ? 'border-red-500' : ''}`} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${id}-error` : undefined} data-id="element-268">
        {options.map(option => <option key={option.value} value={option.value} data-id="element-269">
            {option.label}
          </option>)}
      </select>
      {error && <p id={`${id}-error`} className="mt-1 text-sm text-red-500" role="alert" data-id="element-270">
          {error}
        </p>}
    </div>;
}